// extracted by mini-css-extract-plugin
module.exports = {"container":"_fc","video":"_fd","content":"_fe","contentContainer":"_ff","title":"_fg","text":"_fh","button":"_fi"};